"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  CursorSelectCircle: ['cursor-select-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.284,16.706a11.1,11.1,0,0,1-1.18,2.032', 'M16.938,22.235a7.314,7.314,0,0,1-1.083.459,7.455,7.455,0,0,1-1.125.344', 'M9.292,23.038a7.49,7.49,0,0,1-1.125-.344,7.314,7.314,0,0,1-1.083-.459', 'M2.918,18.739a11.132,11.132,0,0,1-1.179-2.033', 'M.8,11.348a11.1,11.1,0,0,1,.4-2.315', 'M3.924,4.323a12.406,12.406,0,0,1,1.8-1.518', 'M10.835 0.945L12.011 0.883 13.187 0.945', 'M18.3,2.805A12.452,12.452,0,0,1,20.1,4.323', 'M22.819,9.033a11.039,11.039,0,0,1,.4,2.315', 'M8.261 12.133 A3.750 3.750 0 1 0 15.761 12.133 A3.750 3.750 0 1 0 8.261 12.133 Z']],
  HandExpand: ['hand-expand', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.863,20.258l-4.6-5.108a1.564,1.564,0,0,1-.139-1.913h0a1.564,1.564,0,0,1,2.105-.473L7.7,14.247l-1.3-9.084A1.585,1.585,0,0,1,7.591,3.4h0A1.585,1.585,0,0,1,9.53,4.628L10.7,10.5V3.747a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5V10.5l1.182-5.911a1.545,1.545,0,0,1,1.889-1.2h0a1.544,1.544,0,0,1,1.14,1.8L16.7,11.247,19,6.657a1.391,1.391,0,0,1,2.016-.536h0a1.392,1.392,0,0,1,.52,1.674l-2.259,5.648a4.491,4.491,0,0,0-.322,1.671v2.133a4.5,4.5,0,0,1-1.8,3.6h0a4.5,4.5,0,0,1-2.7.9H11.208A4.5,4.5,0,0,1,7.863,20.258Z']],
  CursorAdd: ['cursor-add', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 0.747L3.932 9.233 5.523 5.52 9.235 3.929 0.75 0.747z', 'M8.250 15.747 A7.500 7.500 0 1 0 23.250 15.747 A7.500 7.500 0 1 0 8.250 15.747 Z', 'M15.75 11.997L15.75 19.497', 'M12 15.747L19.5 15.747']],
  CursorDouble: ['cursor-double', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.422,16.608l1.05,2.292a.8.8,0,0,0,1.472-.144l1.793-4.943,4.944-1.794a.8.8,0,0,0,.144-1.472L9.442,4.42', 'M.845,5.8,6.972,19.181a.8.8,0,0,0,1.472-.144l1.793-4.943L15.181,12.3a.8.8,0,0,0,.144-1.472L1.942,4.7A.841.841,0,0,0,.845,5.8Z']],
  Cursor: ['cursor', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.465,4.285,9.776,19.612A.75.75,0,0,0,11,19.856l3.447-3.447,3.712,3.713a.752.752,0,0,0,1.061,0l1.06-1.061a.75.75,0,0,0,0-1.061l-3.712-3.712,3.447-3.447a.75.75,0,0,0-.245-1.224L4.444,3.306A.75.75,0,0,0,3.465,4.285Z']],
  CirclePadFinger: ['circle-pad-finger', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.25,23.247,6.4,18.115a1.534,1.534,0,0,1-.05-1.77h0a1.534,1.534,0,0,1,2.195-.376l1.7,1.278V7.5A1.5,1.5,0,0,1,11.75,6h0a1.5,1.5,0,0,1,1.5,1.5v6l4.174.928a3,3,0,0,1,2.337,3.2l-.511,5.622Z', 'M6.5,13.6A7.5,7.5,0,1,1,18.247,12']],
  CursorDoubleClick2: ['cursor-double-click-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.561,11.492l5.216,11.393a.682.682,0,0,0,1.253-.122l1.527-4.209,4.209-1.526a.683.683,0,0,0,.122-1.254L11.5,10.558A.716.716,0,0,0,10.561,11.492Z', 'M21.723,12q.027-.37.027-.75a10.5,10.5,0,1,0-10.5,10.5c.253,0,.5-.009.75-.026', 'M17.061,9.747A6,6,0,1,0,9.75,17.058']],
  CursorInformation: ['cursor-information', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 14.247 A9.000 9.000 0 1 0 18.750 14.247 A9.000 9.000 0 1 0 0.750 14.247 Z', 'M23.25 0.747L15.75 0.747 23.25 8.247 23.25 0.747z', 'M8.25 12.747L9.75 12.747 9.75 18.747', 'M8.25 18.747L11.25 18.747', 'M9.75,9a.375.375,0,1,0,.375.375A.375.375,0,0,0,9.75,9h0']],
  CursorHand: ['cursor-hand', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.5,11.247v-1.5a1.5,1.5,0,0,0-3,0V9a1.5,1.5,0,0,0-3,0V3a1.5,1.5,0,0,0-3,0v9a3,3,0,0,0-3,3,7.017,7.017,0,0,0,1.308,4.081l1.1,1.535A4.5,4.5,0,0,0,10.566,22.5h3.813A5.121,5.121,0,0,0,19.5,17.376V11.247a1.5,1.5,0,0,0-3,0Z', 'M7.5 11.997L7.5 14.247', 'M10.5 11.247L10.5 9.747', 'M13.5 11.247L13.5 9.747', 'M16.5 11.247L16.5 11.247']],
  CursorDoubleClick1: ['cursor-double-click-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.338,16.964A4.5,4.5,0,1,1,7.5,10.354', 'M18.75,14.247a9,9,0,1,1-9-9', 'M11.224 12.567L23.25 0.747', 'M11.224 8.067L11.224 12.567 15.724 12.567']],
  CursorHand2: ['cursor-hand-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.439,6a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5V17.376A5.118,5.118,0,0,1,18.939,21h0a5.118,5.118,0,0,1-3.621,1.5H12.4a6,6,0,0,1-4.993-2.671l-3.65-5.475a1.541,1.541,0,0,1,0-1.707h0A1.539,1.539,0,0,1,6,12.3l2.439,1.951V4.5A1.5,1.5,0,0,1,9.939,3h0a1.5,1.5,0,0,1,1.5,1.5V3a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5V4.5a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5Z', 'M11.439 4.497L11.439 10.497', 'M14.439 4.497L14.439 10.497', 'M17.439 10.497L17.439 5.997']],
  CursorSelect4: ['cursor-select-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.679,23.043c-.065.265-.2.273-.294.018l-3.9-10.246c-.1-.254.032-.385.288-.289l10.288,3.858c.255.1.248.228-.017.295L17.92,17.96Z', 'M20.533,11.605c-.051.277-.108.558-.171.835', 'M12.16,20.285a5.287,5.287,0,0,1-.762.09', 'M7.011,19.72a10.552,10.552,0,0,0,1.433.441', 'M3.057,16.872a8.16,8.16,0,0,0,1.048,1.07', 'M.84,11.967a14.071,14.071,0,0,0,.326,1.463', 'M1.325,7.117A15.041,15.041,0,0,0,.84,8.734', 'M4.471,2.748a9,9,0,0,0-1.1,1.021', 'M8.912.747a9.606,9.606,0,0,0-1.451.368', 'M12.837.838a10.328,10.328,0,0,1,1.434.44', 'M17.174,3.056a7.98,7.98,0,0,1,1.048,1.071', 'M20.113,7.568a14.071,14.071,0,0,1,.326,1.463']],
  CursorSelect3: ['cursor-select-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.001 0.747L0.751 0.747 0.751 2.997', 'M18.751 0.747L21.001 0.747 21.001 2.997', 'M6.001 0.747L9.001 0.747', 'M12.001 0.747L15.751 0.747', 'M3.001 20.247L0.751 20.247 0.751 17.997', 'M6.001 20.247L9.001 20.247', 'M12.001 20.247L12.751 20.247', 'M0.751 5.997L0.751 8.997', 'M0.751 11.997L0.751 14.997', 'M21.001 5.997L21.001 8.997', 'M21.001 11.997L21.001 12.747', 'M16.686,23.043c-.064.265-.2.273-.293.019L12.5,12.827c-.1-.255.032-.385.287-.289l10.277,3.854c.255.095.248.228-.017.294l-5.121,1.28Z']],
  CursorQuestion: ['cursor-question', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 14.247 A9.000 9.000 0 1 0 18.750 14.247 A9.000 9.000 0 1 0 0.750 14.247 Z', 'M23.25 0.747L15.75 0.747 23.25 8.247 23.25 0.747z', 'M9.75,18.747a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0', 'M6.75,11.247a3,3,0,1,1,4,2.83,1.5,1.5,0,0,0-1,1.414v.631']],
  CursorSelectFrame1: ['cursor-select-frame-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.5.747V6A1.5,1.5,0,0,0,18,7.5h5.25', 'M23.251,16.5H18A1.5,1.5,0,0,0,16.5,18v5.25', 'M7.5,23.247V18A1.5,1.5,0,0,0,6,16.5H.751', 'M.751,7.5H6A1.5,1.5,0,0,0,7.5,6V.747']],
  CursorSelectFrame2: ['cursor-select-frame-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.605,5.247h4.9V.747H3.751a3,3,0,0,0-3,3V10.5H6.584L4.908,6.274A.751.751,0,0,1,5.605,5.247Z', 'M4.908,17.721,6.584,13.5H.751v6.75a3,3,0,0,0,3,3H10.5v-4.5h-4.9A.75.75,0,0,1,4.908,17.721Z', 'M17.417,13.5l1.676,4.224a.749.749,0,0,1-.7,1.026H13.5v4.5h6.75a3,3,0,0,0,3-3V13.5Z', 'M20.251.747H13.5v4.5h4.9a.75.75,0,0,1,.7,1.027L17.417,10.5h5.834V3.747A3,3,0,0,0,20.251.747Z']],
  TouchpadFinger: ['touchpad-finger', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.75,15.747a3,3,0,0,1-3-3v-9a3,3,0,0,1,3-3h16.5a3,3,0,0,1,3,3v9a2.991,2.991,0,0,1-.749,1.984', 'M11.25,23.247,7.4,18.115a1.534,1.534,0,0,1-.05-1.77h0a1.534,1.534,0,0,1,2.195-.376l1.7,1.278V7.5A1.5,1.5,0,0,1,12.75,6h0a1.5,1.5,0,0,1,1.5,1.5v6l4.174.928a3,3,0,0,1,2.337,3.2l-.511,5.622Z']],
  Cursor1: ['cursor-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.816,2.8l8.428,19.072a.75.75,0,0,0,1.411-.112l1.884-7.158a1.5,1.5,0,0,1,1.068-1.069l7.158-1.884a.75.75,0,0,0,.113-1.411L2.806,1.814A.75.75,0,0,0,1.816,2.8Z']],
  CursorTarget: ['cursor-target', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.999 0.747L11.999 23.247', 'M23.249 11.997L0.749 11.997', 'M2.999 11.997 A9.000 9.000 0 1 0 20.999 11.997 A9.000 9.000 0 1 0 2.999 11.997 Z', 'M7.499 11.997 A4.500 4.500 0 1 0 16.499 11.997 A4.500 4.500 0 1 0 7.499 11.997 Z']],
  CursorDoubleClick3: ['cursor-double-click-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.536,11.568l2.68,8.931a.83.83,0,0,0,1.382.349l1.365-1.365,3.522,3.522a.83.83,0,0,0,1.174,0l2.348-2.348a.83.83,0,0,0,0-1.174l-3.522-3.522L20.85,14.6a.83.83,0,0,0-.348-1.382l-8.932-2.68A.831.831,0,0,0,10.536,11.568Z', 'M21.723,10.5A10.5,10.5,0,1,0,10.5,21.721', 'M16.813,9A6,6,0,1,0,9,16.811']],
  CursorSelect1: ['cursor-select-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.361 16.353L19.013 23.247 20.604 20.596 23.256 19.005 16.361 16.353z', 'M23.256 23.247L20.604 20.596', 'M.756,3.747a3,3,0,0,1,3-3', 'M3.756,20.247a3,3,0,0,1-3-3', 'M17.256.747a3,3,0,0,1,3,3', 'M20.256 12.747L20.256 8.247', 'M0.756 12.747L0.756 8.247', 'M8.256 0.747L12.756 0.747', 'M8.256 20.247L12.756 20.247']],
  HandDrag1: ['hand-drag-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.5,8.247v-1.5a1.5,1.5,0,0,0-3,0V6a1.5,1.5,0,0,0-3,0v.75a1.5,1.5,0,0,0-3,0V9a3,3,0,0,0-3,3,7.017,7.017,0,0,0,1.308,4.081l1.1,1.535A4.5,4.5,0,0,0,10.566,19.5h3.813A5.121,5.121,0,0,0,19.5,14.376V8.247a1.5,1.5,0,0,0-3,0Z', 'M7.5 8.997L7.5 11.247', 'M10.5 8.247L10.5 6.747', 'M13.5 8.247L13.5 6.747', 'M16.5 8.247L16.5 8.247']],
  CursorSelect: ['cursor-select', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 7.497L14.25 5.247 16.5 7.497', 'M16.5 20.997L14.25 23.247 12 20.997', 'M14.25 5.247L14.25 23.247', 'M21 11.997L23.25 14.247 21 16.497', 'M7.5 16.497L5.25 14.247 7.5 11.997', 'M23.25 14.247L5.25 14.247', 'M0.75 0.747L3.932 9.233 5.523 5.52 9.235 3.929 0.75 0.747z']],
  CursorTarget2: ['cursor-target-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 15.7L12 23.2', 'M12 0.7L12 8.2', 'M8.3 12L0.8 12', 'M23.3 12L15.8 12', 'M12,11.6L12,11.6c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4\tC12.4,11.8,12.2,11.6,12,11.6']],
  CursorTarget1: ['cursor-target-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.002 17.247L12.002 23.247', 'M12.002 0.747L12.002 6.747', 'M6.752 11.997L0.752 11.997', 'M23.252 11.997L17.252 11.997', 'M3.752 11.998 A8.250 8.250 0 1 0 20.252 11.998 A8.250 8.250 0 1 0 3.752 11.998 Z']],
  CursorHand1: ['cursor-hand-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.5,3A1.5,1.5,0,0,0,10,1.5h0A1.5,1.5,0,0,0,8.5,3v11.25L6.061,12.3a1.539,1.539,0,0,0-2.242.348h0a1.537,1.537,0,0,0,0,1.707l3.65,5.475A6,6,0,0,0,12.461,22.5h2.918A5.118,5.118,0,0,0,19,21h0a5.122,5.122,0,0,0,1.5-3.621V10.5A1.5,1.5,0,0,0,19,9h0a1.5,1.5,0,0,0-1.5,1.5v-.75a1.5,1.5,0,0,0-1.5-1.5h0a1.5,1.5,0,0,0-1.5,1.5,1.5,1.5,0,0,0-1.5-1.5h0a1.5,1.5,0,0,0-1.5,1.5Z', 'M11.5 9.747L11.5 11.997', 'M14.5 9.747L14.5 11.997', 'M17.5 10.497L17.5 11.997']],
  CursorSelectFrame: ['cursor-select-frame', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.255,7.5V2.247a1.5,1.5,0,0,0-1.5-1.5h-5.25', 'M16.505,23.247h5.25a1.5,1.5,0,0,0,1.5-1.5V16.5', 'M.755,16.5v5.25a1.5,1.5,0,0,0,1.5,1.5h5.25', 'M7.505.747H2.255a1.5,1.5,0,0,0-1.5,1.5V7.5']],
  CursorSelectHeart: ['cursor-select-heart', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.213 19.466L9.593 17.778', 'M7.432 15.527L5.812 13.838', 'M3.651,11.587c-.534-.569-1.093-1.114-1.607-1.7', 'M.805,7.054A5.571,5.571,0,0,1,.972,4.725', 'M2.594,2.1a5.752,5.752,0,0,1,2-1.167', 'M7.651.756a5.362,5.362,0,0,1,2.107.952', 'M14.261,1.7A5.333,5.333,0,0,1,16.39.747', 'M19.469.95a5.718,5.718,0,0,1,2,1.206', 'M23.06,4.83a5.707,5.707,0,0,1,.123,2.352', 'M21.861 10.004L20.233 11.711', 'M16.684,23.034c-.064.265-.2.273-.293.018L12.5,12.818c-.1-.255.032-.385.287-.289l10.277,3.854c.255.1.247.228-.017.294l-5.121,1.28Z']],
  CursorType: ['cursor-type', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.251,20.247a3,3,0,0,1-3,3', 'M20.251,3.747a3,3,0,0,1,3,3', 'M6.751,23.247a3,3,0,0,1-3-3', 'M3.751 12.747L3.751 15.747', 'M23.251 11.247L23.251 15.747', 'M15.751 23.247L11.251 23.247', 'M15.751 3.747L12.751 3.747', 'M0.751 0.747L3.933 9.233 5.524 5.52 9.237 3.929 0.751 0.747z', 'M17.251,8.247A3.285,3.285,0,0,1,19.5,7.5', 'M17.251,8.247A3.285,3.285,0,0,0,15,7.5', 'M17.251,19.5a3.285,3.285,0,0,0,2.25.75', 'M17.251,19.5a3.285,3.285,0,0,1-2.25.75', 'M17.251 19.497L17.251 8.247']],
  TouchFinger1: ['touch-finger_1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.477,23.247l-3.85-5.132a1.534,1.534,0,0,1-.049-1.77h0a1.534,1.534,0,0,1,2.195-.376l1.7,1.278V7.5a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v6l4.174.928a3,3,0,0,1,2.337,3.2l-.511,5.622Z', 'M10.977 2.997L10.977 0.747', 'M13.977 3.747L15.477 2.247', 'M7.977 3.747L6.477 2.247', 'M14.727 5.997L16.977 5.997', 'M7.227 5.997L4.977 5.997']],
  HandDrag: ['hand-drag', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.5,6.747v-1.5a1.5,1.5,0,0,0-3,0V4.5a1.5,1.5,0,0,0-3,0v.75a1.5,1.5,0,0,0-3,0V10.5a3,3,0,0,0-3,3,7.017,7.017,0,0,0,1.308,4.081l1.1,1.535A4.5,4.5,0,0,0,10.566,21h3.813A5.121,5.121,0,0,0,19.5,15.876V6.747a1.5,1.5,0,0,0-3,0Z', 'M7.5 10.497L7.5 12.747', 'M10.5 8.997L10.5 5.247', 'M13.5 8.997L13.5 5.247', 'M16.5 8.997L16.5 6.747']],
  CursorSelect2: ['cursor-select-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.751,3.747a3,3,0,0,1,3-3', 'M3.751,20.247a3,3,0,0,1-3-3', 'M17.251.747a3,3,0,0,1,3,3', 'M20.251 12.747L20.251 8.247', 'M0.751 12.747L0.751 8.247', 'M8.251 0.747L12.751 0.747', 'M8.251 20.247L12.751 20.247', 'M14.765 14.762L17.947 23.247 19.538 19.535 23.251 17.944 14.765 14.762z']]
};
exports["default"] = _default;